import { Layout, Menu } from "antd";
import { useState } from "react";

import "./styles.css";

import SideNav from "../SideNav";
import Dashboard from "../Dashboard";
import AddContent from "../AddContent";
import ManageArtists from "../ManageArtists";
import ManageMediaHouses from "../ManageMediaHouses";
import ManagePlans from "../ManagePlans";
import ManangeMovies from "../ManageMovies";
import ManageGenres from "../ManageGenres";
import ManageUsers from "../ManageUsers";
import ManageSeries from "../ManageSeries";
import ManageEpisodes from "../ManageEpisodes";
import ManageOrders from "../ManageOrders";
import ManageAlbums from "../ManageAlbums";
import ManageSongs from "../ManageSongs";
import ManageBanners from "../ManageBanners";
import ManagePlaylists from "../ManagePlaylists";
import ManageDiscounts from "../ManageDiscounts";
import ManageLanguages from "../ManageLanguages";
import ManageEmployees from "../ManageEmployees";
import ManagePartners from "../ManagePartners";
import ManagePermissions from "../ManagePermissions";
import ManageTickets from "../ManageTickets";
import UploadContent from "../UploadContent";
import SubMonitor from "../Reports/subscripitonMonitor";
import UserReports from "../Reports/userReports";
import ContentReports from "../Reports/contentReports";
import ChurnReports from "../Reports/churnReports";
import LikeReports from "../Reports/likeReports";

const { Header, Content } = Layout;

const AdminModule = ({ userEmail, initialTab }) => {
  const [selectedTab, setSelectedTab] = useState(initialTab);

  const navTo = (tab) => {
    sessionStorage.setItem('unpublished', 'yes')
    setSelectedTab(tab)
  }

  const content = {
    "add-content": <AddContent />,
    "upload-content": <UploadContent />,
    dashboard: <Dashboard navTo={navTo} />,
    "manage-artists": <ManageArtists />,
    "manage-media-houses": <ManageMediaHouses />,
    "manage-plans": <ManagePlans />,
    "manage-movies": <ManangeMovies />,
    "manage-genres": <ManageGenres />,
    "manage-users": <ManageUsers />,
    "manage-series": <ManageSeries />,
    "manage-episodes": <ManageEpisodes />,
    "manage-orders": <ManageOrders />,
    "manage-albums": <ManageAlbums />,
    "manage-songs": <ManageSongs />,
    banners: <ManageBanners />,
    playlists: <ManagePlaylists />,
    "manage-discounts": <ManageDiscounts />,
    "manage-languages": <ManageLanguages />,
    "manage-employees": <ManageEmployees />,
    "manage-permissions": <ManagePermissions />,
    "manage-tickets": <ManageTickets />,
    "manage-partners": <ManagePartners />,
    "subscription-monitor": <SubMonitor />,
    "user-reports": <UserReports />,
    "content-reports": <ContentReports />,
    "churn-reports": <ChurnReports />,
    "like-reports": <LikeReports />,
  };

  const logout = async () => {
    await sessionStorage.removeItem("access_token");
    await sessionStorage.removeItem("superadmin");
    await sessionStorage.removeItem("user_email");
    await sessionStorage.removeItem("lastNav");
    window.location.reload();
  };

  const updateTab = (tab) => {
    sessionStorage.removeItem('unpublished')
    setSelectedTab(tab);
    sessionStorage.setItem("lastNav", tab);
  };

  return (
    <>
      <Layout>
        <Header style={{ position: "fixed", zIndex: 1, width: "100%" }}>
          <div className="header-content">
            <img
              src="/images/minipixlogo.svg"
              alt="aao-logo"
              className="header-logo"
            />
            <Menu theme="dark" mode="horizontal">
              <Menu.Item
                key="1"
                onClick={async () => await logout()}
                className="logout-btn"
              >
                Logout
              </Menu.Item>
            </Menu>
          </div>
        </Header>
        <Layout className="site-layout" style={{ marginTop: 64 }}>
          <SideNav updateTab={updateTab} userEmail={userEmail} />
          <Content>
            {content[selectedTab] ||
              "You do not have permissions to view this module"}
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default AdminModule;
